<template src="./RenunciaInicio.html"></template>

<script>
import {requesServelMixin} from "@/api/servelApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {requestRenunciaMixin} from "@/api/ciudadano/renunciaApi";
import moment from "moment";
import {Divider} from "element-ui";

export default {
  name: "RenunciaInicio",
  components: {
    [Divider.name]: Divider,
  },
  mixins: [
    requestRenunciaMixin,
    NotifyMixin,
    ScreenSizeMixin,
    requesServelMixin
  ],
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    validateRenuncia() {
      this.loading = true
      this.renunciaVerificar()
        .then(response => {
          this.$log.debug('renunciaVerificar', response.data.statusCode)
          switch (response.data.statusCode) {
            case 200:
              let datos = response.data.datos

              datos.fecha_afiliacion = moment.utc(datos.fecha_afiliacion, "YYYYMMDD").format('YYYY-MM-DD')
              datos.fecha = moment.utc(datos.fecha_afiliacion, "YYYYMMDD").format('DD-MM-YYYY')
              datos.hora = moment.utc(datos.fecha_afiliacion, "YYYYMMDD").format('HH:mm')

              this.$log.debug(datos)

              this.$emit('on-validation', true, datos)
              break
            case 400:
              this.showError(`Tiene una renuncia a un partido político pendiente.`)
              this.$emit('on-validation', false)
              break
            case 404:
              this.showError(`Actualmente, no tiene una afiliación a un partido político.`)
              this.$emit('on-validation', false)
              break
            case 500:
            default:
              this.showError(`Ocurrió un error inesperado al cargar las validaciones.`)
              this.$emit('on-validation', false)
          }
          this.loading = false
        })
        .catch(err => {
          this.$log.fatal('renunciaVerificar', err)
          this.showError('Ocurrió un error inesperado al cargar las validaciones.')
          this.loading = false

          this.$emit('on-validation', false)
        })
    },
  }

}
</script>
